import { OfferCondition } from '@spilca/order_ts/v1/order/model_offer_pb';
import { PaymentSchedule } from '@spilca/order_ts/v1/order/model_multi_order_pb';
import { timestampConstructor } from '@monorepo/helpers';

const offerConditionConstructor = ({
  deliveryCondition,
  deliveryDate,
  deliveryDeadline,
  deliveryPlace,
  deliveryReceiver,
  paymentCondition,
  paymentDate,
  expiredDate,
  financialSupportType,
  transportType,
  paymentType,
  paymentScheduleList
}: Partial<OfferCondition.AsObject>): OfferCondition => {
  const offerCondition = new OfferCondition();
  if (deliveryCondition) {
    offerCondition.setDeliveryCondition(deliveryCondition);
  }
  if (transportType) {
    offerCondition.setTransportType(transportType);
  }
  if (deliveryDate) {
    offerCondition.setDeliveryDate(timestampConstructor(deliveryDate));
  }
  if (deliveryDeadline) {
    offerCondition.setDeliveryDeadline(timestampConstructor(deliveryDeadline));
  }
  if (deliveryPlace) {
    offerCondition.setDeliveryPlace(deliveryPlace);
  }
  if (deliveryReceiver) {
    offerCondition.setDeliveryReceiver(deliveryReceiver);
  }
  if (paymentCondition) {
    offerCondition.setPaymentCondition(paymentCondition);
  }
  if (paymentDate) {
    offerCondition.setPaymentDate(timestampConstructor(paymentDate));
  }
  if (expiredDate) {
    offerCondition.setExpiredDate(timestampConstructor(expiredDate));
  }
  if (financialSupportType) {
    offerCondition.setFinancialSupportType(financialSupportType);
  }
  if (paymentType) {
    offerCondition.setPaymentType(paymentType);
  }

  if (paymentScheduleList && paymentScheduleList.length > 0) {
    const scheduleMessages = paymentScheduleList.map((item) => {
      const schedule = new PaymentSchedule();
      schedule.setPayment(item.payment);
      if (item.date) {
        schedule.setDate(timestampConstructor(item.date));
      }
      return schedule;
    });
    offerCondition.setPaymentScheduleList(scheduleMessages);
  }

  return offerCondition;
};

export default offerConditionConstructor;
